module.exports = __webpack_public_path__ + "img/824.884e6383.png";